// @flow @jsx h

/* eslint-disable promise/always-return */

import { h, Component } from 'preact'
import superagent from 'superagent'
import { connect } from '../../lib/provider'
import Info from './Info'
import Map from './Map'
import Select from './Select'
import SuggestSearch from './SuggestSearch'

import styles from './App.css'

type Props = {
  sendGaEvent: Object => void,
  api: {
    baseUrl: string
  },
  mapbox: {
    accessToken: string
  }
}

type State = {
  municipalityId: string | null,
  municipalityName: string | null,
  fires: any | null,
  municipality: any | null,
  fireName: string | null
}

class _App extends Component<Props, State> {
  state = {
    municipalityId: '1103',
    municipalityName: 'Stavanger',
    fires: null,
    municipality: null,
    fireName: 'Enskogen'
  }

  componentDidMount () {
    superagent
      .get(`${this.props.api.baseUrl}/fires`)
      .then(res => {
        this.setState({ fires: res.body })
      })
      .catch(err => {
        console.log(err)
      })

    this.loadMunicipality()
  }

  componentDidUpdate (prevProps: Props, prevState: State) {
    if (prevState.municipalityId !== this.state.municipalityId) {
      this.loadMunicipality()
    }
  }

  loadMunicipality () {
    const { municipalityId } = this.state

    this.setState({ municipality: null })

    if (!municipalityId) {
      return
    }

    superagent
      .get(`${this.props.api.baseUrl}/municipality/${municipalityId}`)
      .then(res => {
        this.setState({ municipality: res.body })
      })
      .catch(err => {
        console.log(err)
      })
  }

  handleSubmit = (evt: any) => {
    evt.preventDefault()
  }

  handleSelectMunicipality = (
    municipalityId: string,
    municipalityName: string
  ) => {
    this.setState({ municipalityId, municipalityName })
  }

  handleFireSelectBlur = (evt: any) => {
    this.setState({ fireName: evt.target.value || null })
  }

  handleFireSelectChange = (evt: any) => {
    this.setState({ fireName: evt.target.value || null })
  }

  render () {
    const { municipality, municipalityName, fires, fireName } = this.state
    const fireMatches = fires ? fires.filter(fire => fire.id === fireName) : []
    const currentFire = fireMatches[0] || null

    return (
      <section class={styles.app}>
        <header class={styles.app__header}>
          <form class={styles.app__form} onSubmit={this.handleSubmit}>
            <div>
              <SuggestSearch
                ajax={`${this.props.api.baseUrl}/municipalities?q={{value}}`}
                onSelect={this.handleSelectMunicipality}
                value={municipalityName}
              />
            </div>
            <div>
              <Select
                disabled={this.state.municipalityId === null}
                id='dh-skogbrann-select'
                label='Velg skogbrann'
                value={this.state.fireName}
                onBlur={this.handleFireSelectBlur}
                onChange={this.handleFireSelectChange}
                options={
                  fires
                    ? fires.map((fire, idx) => ({
                      value: fire.id,
                      label: `Brannen i ${fire.id}`
                    }))
                    : []
                }
              />
            </div>
          </form>
        </header>

        <div class={styles.app__mapWrapper}>
          <Map
            accessToken={this.props.mapbox.accessToken}
            fires={this.state.fires}
            municipality={this.state.municipality}
            fireName={this.state.fireName}
          />
        </div>

        {municipality &&
          currentFire && (
          <Info
            municipalityName={municipalityName}
            municipality={municipality}
            fireName={fireName}
            fire={currentFire}
          />
        )}

        <footer class={styles.app__footer}>
          <div class={styles.app__sources}>
            KILDER: Copernicus EMS, SSB, Kartverket
          </div>
        </footer>
      </section>
    )
  }
}

/*
const mapContextToProps = context => ({
  ...context,
  sendCustomGaEvent: () => context.sendEvent({ action: 'my custom event action' })
})
*/

const connector = connect()
// const connector = connect(mapContextToProps)
export const App = connector(_App)



// WEBPACK FOOTER //
// ./src/v1/components/App.js